var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas1",staticStyle:{"background-color":"transparent"},attrs:{"width":"200","height":"700"}}),_c('canvas',{ref:"canvas2",staticStyle:{"left":"125px","background-color":"transparent"},attrs:{"width":"200","height":"700"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }